import Vue from 'vue'

export const InvoicesService = {
  list (params = []) {
    return Vue.axios.get('/invoices', { params })
      .then((response) => response.data)
  },

  download (params = []) {
    return Vue.axios.get('/invoices/download',
      {
        params,
        responseType: 'blob',
        headers: { 'Accept': 'application/vnd.ms-excel' }
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'data.xlsx')
        document.body.appendChild(link)
        link.click()
      })
  }
}
